var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("emd-modal", {
    attrs: { "has-header": "", open: _vm.open },
    on: { close: _vm.togglePixModal },
    scopedSlots: _vm._u([
      {
        key: "header",
        fn: function () {
          return [
            _c(
              "h2",
              { staticClass: "emd-text _size_section _color_secondary" },
              [
                _vm._v(
                  " " +
                    _vm._s(
                      _vm.$t("charge.detail.payment-method.pix.modal.title")
                    ) +
                    " "
                ),
              ]
            ),
          ]
        },
        proxy: true,
      },
      {
        key: "content",
        fn: function () {
          return [
            _c("div", { staticClass: "eu-mt_4" }, [
              _c("p", [
                _vm._v(
                  _vm._s(
                    _vm.$t("charge.detail.payment-method.pix.modal.subtitle")
                  )
                ),
              ]),
              _c(
                "p",
                {
                  staticClass: "emd-text _color_default _type_caption eu-mb_1",
                },
                [
                  _vm._v(
                    " " +
                      _vm._s(
                        _vm.$t(
                          "charge.detail.payment-method.pix.modal.description"
                        )
                      ) +
                      " "
                  ),
                ]
              ),
            ]),
            _c("div", { staticClass: "eu-py_6 eu-align_center" }, [
              _c("img", { attrs: { src: _vm.qrCodeUrl, alt: "QR code url" } }),
            ]),
            _c("p", [
              _vm._v(
                " " +
                  _vm._s(
                    _vm.$t("charge.detail.payment-method.pix.modal.charge", {
                      charge: _vm.chargeId,
                    })
                  ) +
                  " "
              ),
            ]),
          ]
        },
        proxy: true,
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }